import {RouterLink} from "@angular/router";
import {appRoutes} from "@numizmat/constants";
import {Component, Input} from '@angular/core';

import {PopularAdCategoryResponse} from "@numizmat/services-models/core";

@Component({
    selector: 'nz-categories-section',
    imports: [
        RouterLink
    ],
    templateUrl: './categories-section.component.html',
    styleUrl: './categories-section.component.scss'
})
export class CategoriesSectionComponent {
  @Input() popularAdCategories: PopularAdCategoryResponse[] = [];

  protected readonly appRoutes = appRoutes;
}
